
// v4: @material-ui/core/styles


import { makeStyles } from '@mui/styles';
import { white, black, errorDark, green60, grey7c, red, neutralDarkGray } from '../colors';

export const useCommonStyles = makeStyles(() => ({
    fullWidth: { width: '100%' },
    label15Noto: {
        fontSize: 15,
        fontWeight: 600
    },
    greyButton: {
        fontWeight: 400,
        fontStyle: 'normal',
        fontSize: 16,
        backgroundColor: '#6D6D6D',
        textTransform: 'none',
        width: 'auto',
        color: white,
        whiteSpace: 'nowrap',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& .MuiButton-startIcon, & .MuiButton-endIcon': {
            display: 'inherit',
            alignItems: 'center',
        },
    },
    greenButton: {
        fontWeight: 500,
        fontSize: 16,
        color: white,
        backgroundColor: green60,
        textTransform: "none",
        whiteSpace: 'nowrap',
        width: 'auto',
        borderRadius: 4,
        height: "40px",
        boxShadow: "none",
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& .MuiButton-startIcon, & .MuiButton-endIcon': {
            display: 'inherit',
            alignItems: 'center',
        },
        '&:active': {
            color: white,
        },
        "&:hover": {
            boxShadow: "1px 2px 5.3px 0px #00000057",
            outline: "none"
        },
        "&:focus": {
            boxShadow: "none",
            outline: "none"
        }
    },
    tabStyleDefault: {

        fontWeight: 600,
        fontStyle: 'normal',
        fontSize: 15,
        lineHeight: 20,
        letterSpacing: '-0.24px',
        textAlign: 'center',
        verticalAlign: 'middle'
    },

    italicText: {
        fontStyle: 'italic',
    },
    gridRowText: {
        fontSize: 14,
        fontWeight: 400
    },
    whiteButton: {
        fontWeight: 400,
        fontStyle: 'normal',
        fontSize: 16,
        backgroundColor: white,
        color: black,
        textTransform: 'none',
        whiteSpace: 'nowrap',
        height: "40px",
        border: "1px solid #000000",
        boxShadow: "none",
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& .MuiButton-startIcon, & .MuiButton-endIcon': {
            display: 'inherit',
            alignItems: 'center',
        },
        "&:hover": {
            boxShadow: "1px 2px 5.3px 0px #00000057", borderColor: "#000000",
            outline: "none"
        },
        "&:focus": {
            boxShadow: "none", borderColor: "#000000",
            outline: "none"
        }
    },
    labelInter16: {
        fontSize: 16,
        fontWeight: 400,
    },
    processingStepsLabel: {
        fontWeight: 400,
        fontStyle: 'normal',
        fontSize: 16,
        lineHeight: '24px',
        letterSpacing: '-0.31px',
        color: '#0A0A0A',
    },
    labelInter14: {
        fontSize: 14,
        fontWeight: 400,
    },
  
    labelInter16Bold: {
        fontWeight: 700,
        fontSize: 16,
        fontStyle: "bold"
    },
   
    labelInter16Bold400: {
        fontWeight: 400,
        fontSize: 16,
        fontStyle: 'normal',

    },
   
    labelInter18Bold500: {
        fontWeight: 500,
        fontSize: 18,
        fontStyle: 'bold',
        color: white
    },
    labelNoto16Bold600: {
        fontWeight: 600,
        fontSize: 16
    },
    filterButtonStyle: {
        fontWeight: 600,
        fontSize: 16,
        color: black,
        backgroundColor: white,
        textTransform: 'none',
        whiteSpace: 'nowrap',
        height: 40,
        border: "1px solid #000000",
        padding: "10px 30px",
        boxShadow: "none",
        width: 120,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& .MuiButton-startIcon, & .MuiButton-endIcon': {
            display: 'inherit',
            alignItems: 'center',
        },
        "&:hover": {
            boxShadow: "1px 2px 5.3px 0px #00000057", borderColor: "#000000",
            outline: "none"
        },
        "&:focus": {
            boxShadow: "none", borderColor: "#000000",
            outline: "none"
        }
    },
    selectedChipFilterButton: {
        fontWeight: 500,
        fontSize: 14,
        color: white,
        backgroundColor: green60,
        textTransform: "none",
        whiteSpace: 'nowrap',
        height: 32,
        borderRadius: 12,
        padding: '4px 16px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: "none",
        '&:active': {
            color: white,
        },
        "&:hover": {
            boxShadow: "1px 2px 5.3px 0px #00000057",
            outline: "none"
        },
        "&:focus": {
            boxShadow: "none",
            outline: "none"
        }
    },
    chipFilterButton: {
        height: 32,
        borderRadius: 12,
        padding: '4px 16px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        textTransform: 'none',
        whiteSpace: 'nowrap',
        fontWeight: 500,
        fontSize: 14,
        background: white,
        color: "#0A0A0A",
        border: "1px solid #000000",
        "&:hover": {
            boxShadow: "1px 2px 5.3px 0px #00000057", borderColor: "#000000",
            outline: "none"
        },
        "&:focus": {
            boxShadow: "none", borderColor: "#000000",
            outline: "none"
        }
    },
    chipFilterButtonText: {
        fontWeight: 500,
        fontStyle: 'normal',
        fontSize: 14,
        lineHeight: '20px',
        letterSpacing: '-0.15px',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        gap: '4px'
    },
    chipFilterButtonTextBold: {
        fontWeight: 700,
        fontStyle: 'normal',
        fontSize: 14,
        lineHeight: '20px',
        letterSpacing: '-0.15px',
        textAlign: 'center',
        color: "#0A0A0A"
    },
    quickFilterChipButton: {
        width: '130px',
        height: 32,
        marginRight: '12px',
        gap: '12px',
        padding: '10px 4px',
        borderRadius: 20,
        border: '0.5px solid',
        textTransform: 'none',
        backgroundColor: '#DCF8D8',
        borderColor: '#00AC4F',
        color: '#404040',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        "&:hover": {
            boxShadow: "1px 2px 5.3px 0px #00000057", borderColor: "#00AC4F",
            outline: "none"
        },
        "&:focus": {
            boxShadow: "none", borderColor: "#00AC4F",
            outline: "none"
        }
    },
    createMaterialLabelButton: {
        width: 212,
        height: 40,
        gap: '4px',
        padding: '10px 12px',
        borderRadius: 4,
        borderWidth: 1,
        borderColor: '#000000',
        color: '#000000',
        textTransform: 'none',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& .MuiButton-startIcon, & .MuiButton-endIcon': {
            display: 'inherit',
            alignItems: 'center',
        },
        '&:hover': {
            borderColor: '#000000',
            boxShadow: '1px 2px 5.3px 0px #00000057',
        },
    },
    createMaterialLabelText: {
        fontWeight: 500,
        fontSize: 16,
        lineHeight: '16px',
        letterSpacing: 0,
        textAlign: 'center',
        color: '#404040',
        textTransform: 'none',
    },
    moduleName: {
    },
    landingPageCardMedia: {
        width: 384, height: 445, display: 'block'
    },
    errorText: {
        color: errorDark
    },
    labelInter14500: {
        fontSize: 14,
        fontWeight: "bold",
    },
    labelInter12: {
        fontSize: 12,
        fontWeight: 400,
    },
    labelNoto14Bold400: {
        fontWeight: 400,
        fontSize: 14
    },
    labelNoto14Bold500: {
        fontWeight: 500,
        fontSize: 14,
        lineHeight: '21px'
    },
    labelNoto12Bold500: {
        fontWeight: 500,
        fontSize: 12
    },
    labelNoto16Bold400: {
        fontWeight: 400,
        fontSize: 16
    },
    labelNoto12Bold400: {
        fontWeight: 400,
        fontSize: 12
    },
    labelNoto14500: {
        fontSize: 30,
        fontWeight: "bold",
    },
    labelNoto30700: {
        fontSize: 30,
        fontWeight: "bold",
    },
    labelInter14Bold400: {
        fontWeight: 400,
        fontSize: 14,
        fontStyle: 'normal',
    },
    labelNoto14Bold700: {
        fontWeight: 700,
        fontSize: 14,
        color: '#0A0A0A'
    },
    labelNoto16Regular400: {
        fontWeight: 400,
        fontStyle: 'normal',
        fontSize: 16,
        lineHeight: '24px',
        letterSpacing: '-0.31px',
    },
    labelNoto16Bold700: {
        fontWeight: 700,
        fontSize: 16
    },
    labelNoto20Bold600: {
        fontWeight: 600,
        fontSize: 20
    },
    labelNoto24Bold400: {
        fontWeight: 400,
        fontSize: 24,
        lineHeight: '100%',
        letterSpacing: 0
    },
    steeperIncomplete: {
        backgroundColor: white,
        width: 28,
        height: 28,
        fontSize: 14,
        border: `1px solid #808080`,
        color: grey7c,
        fontWeight: 700,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "inset 0 0 0 2px #808080"
    },
    steeperIncomStep: {
        backgroundColor: white,
        width: 20,
        height: 20,
        fontSize: 12,
        fontWeight: 300,
        border: `2px solid ${grey7c}`,
        color: grey7c,
    },
    filerChip: {

        border: "1px solid #000000",
        borderRadius: 4,
        width: 157,
        height: 32,
        opacity: 1,
        gap: 8,
        padding: '10px 12px',
        cursor: "pointer",
        fontWeight: 400,
        fontSize: 14,
        fontStyle: 'normal',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    labelNoto36Bold700: {
        fontWeight: 700,
        fontSize: 36
    },
    labelNoto36Bold600: {
        fontWeight: 600,
        fontSize: 36
    },
    labelNoto16Bold500: {
        fontWeight: 500,
        fontSize: 16
    },
    labelInter12400: {
        fontSize: 12,
        fontWeight: 400,
    },
    labelNoto15Bold500: {
        fontWeight: 500,
        fontSize: 14
    },

    blueButton: {
        fontWeight: 500,
        fontSize: 16,
        color: white,
        backgroundColor: "#1E5BFF",
        textTransform: 'none',
        whiteSpace: 'nowrap',
        borderRadius: "4px",
        height: 40,
        boxShadow: "none",
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& .MuiButton-startIcon, & .MuiButton-endIcon': {
            display: 'inherit',
            alignItems: 'center',
        },
        "&:hover": {
            boxShadow: "1px 2px 5.3px 0px #00000057",
            outline: "none"
        },
        "&:focus": {

            outline: "none"
        }
    },
    blackButton: {
        fontWeight: 500,
        fontSize: 15,
        color: white,
        backgroundColor: black,
        textTransform: 'none',
        whiteSpace: 'nowrap',
        borderRadius: "4px",
        border: '1px solid #000000',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& .MuiButton-startIcon, & .MuiButton-endIcon': {
            display: 'inherit',
            alignItems: 'center',
        },
    },
    redBorderRedLabel: {
        fontWeight: 500,
        fontSize: 16,
        color: red,
        backgroundColor: white,
        textTransform: 'none',
        whiteSpace: 'nowrap',
        borderRadius: "4px",
        border: "1px solid #D8010B",
        boxShadow: "none",
        height: 40,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& .MuiButton-startIcon, & .MuiButton-endIcon': {
            display: 'inherit',
            alignItems: 'center',
        },
        "&:hover": {

            border: "1px solid #D8010B", outline: "none"
        },
        "&:focus": {
            boxShadow: "none",

            border: "1px solid #D8010B", outline: "none"
        }
    },
    neutralDarkGrayLabel: {
        fontWeight: 500,
        fontSize: 15,
        color: white,
        backgroundColor: neutralDarkGray,
        textTransform: 'none',
        whiteSpace: 'nowrap',
        borderRadius: "8px",
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    redButton: {
        fontWeight: 500,
        fontSize: 15,
        color: white,
        backgroundColor: "#D8010B",
        textTransform: 'none',
        whiteSpace: 'nowrap',
        borderRadius: "4px",
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& .MuiButton-startIcon, & .MuiButton-endIcon': {
            display: 'inherit',
            alignItems: 'center',
        },
    },
    labelNoto18Bold500: {
        fontWeight: 500,
        fontSize: 18
    },
    labelNoto20Bold500: {
        fontWeight: 500,
        fontSize: 20
    },
    labelNoto28Bold600: {
        fontWeight: 600,
        fontSize: 28,
        lineHeight: '30px',
        letterSpacing: 0
    },
    archiveButtonStyle: {
        fontWeight: 400,
        fontSize: '16px',
        height: '40px',
        color: black,
        backgroundColor: white,
        textTransform: 'none',
        whiteSpace: 'nowrap',
        border: "1px solid #000000",
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& .MuiButton-startIcon, & .MuiButton-endIcon': {
            display: 'inherit',
            alignItems: 'center',
        },
        "&:hover": {
            boxShadow: "1px 2px 5.3px 0px #00000057", borderColor: "#000000",
            outline: "none"
        },
        "&:focus": {
            boxShadow: "none", borderColor: "#000000",
            outline: "none"
        }
    },
    labelNoto26Bold400: {
        fontWeight: 400,
        fontSize: 26
    },
    labelNoto20Bold700: {
        fontWeight: 700,
        fontSize: 20
    },
    labelNoto14Bold600: {
        fontWeight: 600,
        fontSize: 14
    },
    steeperIncompleteSmall: {

        backgroundColor: white,
        width: 18,
        height: 18,
        fontSize: 10,
        border: `1px solid #808080`,
        color: grey7c,
        fontWeight: 600,
        boxShadow: "inset 0 0 0 1px #808080",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",

    },
    dropdownPlaceHolder: {
        fontSize: 16
    },
    labelNoto18Bold600: {
        fontWeight: 600,
        fontSize: 18
    },
    filterCloseButton: {
        color: "#1E1E1E",
        top: 10,
        right: 8,
        position: "absolute",
        
        '&:focus': { outline: 'none' },
        '&.Mui-focusVisible': { outline: 'none' },
        '&:focus-visible': { outline: 'none' },
    },

    dropdownMenuItem: {
        padding: "0px 0px",
        height: "28px",
    },
     labelNoto12600: {
        fontSize: 26,
        fontWeight: 600,
    },
     labelNoto24Bold600: {
        fontWeight: 600,
        fontSize: 24,
        lineHeight: '100%',
        letterSpacing: 0
    },

    // ── Handheld (+30% font size) variants ─────────────────────────────────
    labelNoto12Bold400_hh: {
        fontWeight: 400,
        fontSize: 15.6,
    },
    labelNoto12Bold500_hh: {
        fontWeight: 500,
        fontSize: 15.6,
    },
    labelNoto14Bold400_hh: {
        fontWeight: 400,
        fontSize: 18.2,
    },
    labelNoto14Bold500_hh: {
        fontWeight: 500,
        fontSize: 18.2,
        lineHeight: '27.3px',
    },
    labelNoto14Bold600_hh: {
        fontWeight: 600,
        fontSize: 18.2,
    },
    labelNoto14Bold700_hh: {
        fontWeight: 700,
        fontSize: 18.2,
        color: '#0A0A0A',
    },
    labelNoto16Bold400_hh: {
        fontWeight: 400,
        fontSize: 20.8,
    },
    labelNoto16Bold500_hh: {
        fontWeight: 500,
        fontSize: 20.8,
    },
    labelNoto16Bold700_hh: {
        fontWeight: 700,
        fontSize: 20.8,
    },
    labelNoto20Bold500_hh: {
        fontWeight: 500,
        fontSize: 23.4,
    },
    labelNoto26Bold400_hh: {
        fontWeight: 400,
        fontSize: 33.8,
    },
    blueButton_hh: {
        fontWeight: 500,
        fontSize: 20.8,
        color: '#FFFFFF',
        backgroundColor: '#1E5BFF',
        textTransform: 'none' as const,
        whiteSpace: 'nowrap' as const,
        borderRadius: '4px',
        height: 40,
        boxShadow: 'none',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& .MuiButton-startIcon, & .MuiButton-endIcon': {
            display: 'inherit',
            alignItems: 'center',
        },
        '&:hover': {
            boxShadow: '1px 2px 5.3px 0px #00000057',
            outline: 'none',
        },
        '&:focus': {
            outline: 'none',
        },
    },
    
}));
